// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1BmQO","brandName":"Footer_brandName__9-gpG"};